<template>
<div class="flight" :style="{ height: `${windowHeight}px`, 'overflow-y': 'auto' }">
	<el-form :inline="true" size="mini" style="padding-left:10px" label-width="80">
		<el-form-item :label="flight_lang.flighttype">
			<el-input type="text" v-model="info.f_name" style="width:200px"></el-input>
		</el-form-item>
		<el-form-item :label="flight_lang.startport">
			<el-select v-model="info.startport" :filterable="true" :clearable="true" style="width:200px">
				<el-option v-for="port in portlist" :key="port.value" :value="port.value" :label="port.value"></el-option>
			</el-select>
		</el-form-item>
	</el-form>
		<table class="tablecss" cellspacing="0">
			<thead>
				<td class="td6" style="height:32px;">{{flight_lang.endport}}</td>
				<td class="td6">{{flight_lang.flightnum}}</td>
				<td class="td6">{{flight_lang.broadnarrow}}</td>
				<td class="td6">{{flight_lang.etd}}</td>
				<td class="td6">{{flight_lang.eta}}</td>
				<td class="td6">{{flight_lang.flightcycle}}</td>
				<td class="td6">{{flight_lang.carrying}}</td>
				<td class="td6">{{flight_lang.deadline}}</td>
				<td class="td6">{{flight_lang.remark}}</td>
				<td class="td7"></td>
			</thead>
			<tbody>
				<!-- <div style="height:380px;overflow-y:auto;"> -->
					<tr v-for="(item,i) in flightlist" :key="i">
						<td class="td6" style="height:32px;">
							<el-select v-model="item.endport" size="mini" :filterable="true" :clearable="true">
								<el-option v-for="port in portlist" :key="port.value" :value="port.value" :label="port.value"></el-option>
							</el-select>
						</td>
						<td class="td6">
							<el-input type="text" size="mini" v-model="item.flightnum">
								
							</el-input>
						</td>
						<td class="td6">
							<el-input type="text" size="mini" v-model="item.broadnarrow">
								
							</el-input>
						</td>
						<td class="td6">
							<el-input type="text" size="mini" v-model="item.etd">
								
							</el-input>
						</td>
						<td class="td6">
							<el-input type="text" size="mini" v-model="item.eta">
								
							</el-input>
						</td>
						<td class="td6">
							<el-input type="text" size="mini" v-model="item.flightcycle">
								
							</el-input>
						</td>
						<td class="td6">
							<el-input type="text" size="mini" v-model="item.carrying">
								
							</el-input>
						</td>
						<td class="td6">
							<el-input type="text" size="mini" v-model="item.deadline">
								
							</el-input>
						</td>
						<td class="td6">
							<el-input type="text" size="mini" v-model="item.remark">
								
							</el-input>
						</td>
						<td class="td7">
							<i class="el-icon-delete" style="color:red" @click="delflight(i)"></i>
						</td>
					</tr>
									
				<!-- </div> -->
			</tbody>
		</table>
		<div style="margin-top:5px;margin-left:5px">
			<el-button size="mini" type="primary" @click="addflight">{{flight_lang.addflight}}</el-button>
		</div>
	</el-card>
	<el-card class="box-card" style="margin-top:10px;">
		<div slot="header" class="clearfix">
			<span style="margin-right:28px">{{flight_lang.tips}}  </span>
		</div>
		<el-row>
			<el-col :span="24">
				<div id="editor" ref="editor" style="margin-top:-10px" class="diveditor"></div>
			</el-col>
		</el-row>
	</el-card>
	<el-row class="footerhandler">
		<el-col :span="5" style="color:transparent;">1</el-col>
		<el-col :span="4" class="submitBtn"><div @click="saveflight">{{suretext}}</div></el-col>
		<el-col :span="4" class="submitBtn_cancel"><div @click="cancel">{{canceltext}}</div></el-col>
	</el-row>
</div>
</template>

<script>
import E from 'wangeditor';
import Utils from '../../lib/util.js';
export default {
	components: {
		
	},
	props: {
		urlparam: {
			type: Object,
			default:function(){
				return {};
			}
		},
		item:{
			type: Object,
			default:function(){
				return {
					
				};
			}
		}
	},
	data() {
		return {
			showflight:false,
			flight_lang:{},
			editor: {},
			flightlist:[{endport:'',flightnum:'',broadnarrow:'',etd:'',eta:'',flightcycle:'',carrying:'',deadline:'',remark:''}],
			f_id:'',
			c_id:'',
			info:{
				f_id:'',
				startport:'',
				f_name:'',
				remark:''
			},
			portlist:[],
			suretext:'',
			canceltext:'',
			windowHeight: window.innerHeight - 145,
		};
	},
	mounted(){
		import('../../static/' + this.$theme + '/style/cw/setbaojia.scss');
		this.init();
	},
	methods:{
		init(){
			debugger
			if(this.urlparam.c_id!=undefined)
				this.c_id=this.urlparam.c_id;
			this.loadlanguage();
			this.loadportlist();
		},
		loadlanguage(){
			var that=this;
			this.$public.GetLanguageByMode('flight',this).then(res=>{
				if(res.state=='1')
					that.flight_lang=that.$lang.label.flight;
				that.suretext=that.$lang.label.public.sure;
				that.canceltext=that.$lang.label.public.cancel;
				that.loadflight();
			});
		},
		loadportlist(){
			var that=this;
			this.$apipost.get.dic({type:'港口'}).then(res=>{
				if(res.list!=undefined){
					that.portlist=res.list;
				}
			});
		},
		loadflight(){
			var that=this;
			if(this.c_id!=''){
				//debugger
				this.$apipost.get.GetFlightMain({c_id:this.c_id}).then(res=>{
					if(res.state=='1')
					{
						that.info=res.info;
						that.initEditor();
						that.loadflightlist(res.info.f_id);
					}else{
						that.initEditor();
					}
				});
			}else
				this.initEditor();
		},
		loadflightlist(f_id){
			var that=this;
			this.$apipost.get.GetFlightList({f_id:f_id}).then(res=>{
				if(res.state=='1'){
					that.info.startport=res.startport;
					that.flightlist=res.list;
				}
				else
					this.$tool.message(that.flight_lang.getinfofail, 0);
			});
		},
		addflight(){
			debugger
			var item=JSON.parse(JSON.stringify(this.flightlist[0]));
			for(var i in item)
				item[i]="";
			this.flightlist.push(item);
		},
		delflight(index){
			if(this.flightlist.length>0&&index>0)
				this.flightlist.splice(index,1);
		},
		initEditor() {
			var html='';
			if(this.info!='')
				html=this.info.remark;
			this.editor = new E(this.$refs.editor);
			this.editor.config.height =230;
			this.editor.config.excludeMenus = ['emoticon','image', 'video', 'undo', 'redo', 'todo'];
			this.editor.config.showLinkImg = false;
			this.editor.config.placeholder =this.flight_lang.remarkplaceholder;
			this.editor.create();
			if(html!=undefined)
				this.editor.txt.html(html);
		},
		saveflight(){
			var that=0;
			//回填航班信息到父页面
			var list=JSON.parse(JSON.stringify(this.flightlist));
			if(this.flightlist.length>0){
				var list=this.flightlist.filter(function(e){
					return e.endport=='';
				});
				if(list.length>0){
					this.$tool.message(this.$lang.label.public.pleasewrite+this.flight_lang.endport, 0);
					return false;
				}
				list=this.flightlist.filter(function(e){
					return e.flightnum=='';
				});
				if(list.length>0){
					this.$tool.message(this.$lang.label.public.pleasewrite+this.flight_lang.flightnum, 0);
					return false;
				}
			}
			this.$emit('flightcallback',{list:this.flightlist,info:this.info});
			this.cancel();
		},
		cancel(){
			this.$emit('handleRermove', localStorage.getItem('tabname'));
		}
	}
}
</script>

<style>
</style>